export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-07.f7e03082.jpg";